<script>
  import { onMount, tick } from 'svelte';
  import Splide from '@splidejs/splide';
  import '@splidejs/splide/dist/css/splide.min.css';

  export let data = [];
  let items = [];

onMount(() => {
  items = data;

  tick().then(() => {
    // wait for DOM to update
    new Splide('.splide', {
      type: 'slide',
      perPage: 2,
      focus: 'center',
      gap: '2rem',
      padding: '5%',
      autoplay: true,
      rewind: true,
      breakpoints: {
        1024: {
          perPage: 1,
          padding: '10%',
          gap: '1.5rem',
        },
        768: {
          perPage: 1,
          padding: '5%',
          gap: '1rem',
        },
      },
    }).mount();
  });
});
</script>
<div class="splide">
  <div class="splide__track">
    <ul class="splide__list">
      {#each items as item}
        <li class="splide__slide">
          <a href={item.permalink}>
            <div class="slide-img">
              <img
                src={item.thumbnail}
                srcset={item.thumbnailSrcset}
                sizes={item.thumbnailSizes || '(max-width: 1024px) 90vw, 560px'}
                width={item.thumbnailWidth}
                height={item.thumbnailHeight}
                loading={item.isPriority ? 'eager' : 'lazy'}
                fetchpriority={item.isPriority ? 'high' : undefined}
                decoding="async"
                alt={item.title}
              />
            </div>
            <!-- <h3>{item.title}</h3> -->
          </a>
        </li>
      {/each}
    </ul>
  </div>
</div>

<style>
  .splide__slide {
    padding: 1rem;
    text-align: center;
    position: relative;
    transition: all 0.3s ease;
  }
  .splide__slide .slide-img { 
    width: 100%;
    height: 500px;
    position: relative;
  }
  .splide__slide img {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
    top: 0;
    left: 0;
    transition: opacity 0.3s ease;
  }

  .splide__slide h3 {
    margin-top: 0.75rem;
    font-size: 1.1rem;
    position: absolute;
    bottom: 1rem;
    left: 1rem;
    color: white;
    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.5);
  }

  .splide__slide:not(.is-active)::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.45);
    z-index: 2;
    transition: background 0.3s ease;
  }

  .splide__slide.is-active::before {
    background: transparent;
  }

  .splide__slide a {
    display: block;
    position: relative;
  }

</style>